import React from 'react';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import { SidebarNav } from './components';
import { NavPages } from 'layouts/Main/navigation';

interface SidebarProps {
  pages: NavPages;
  open: boolean;
  variant: DrawerProps['variant'];
  onClose: () => void;
}

const Sidebar = ({ pages, open, variant, onClose }: SidebarProps) => {
  return (
    <Drawer
      anchor="left"
      onClose={() => onClose()}
      open={open}
      variant={variant}
      sx={{
        '& .MuiPaper-root': {
          width: '100%',
          maxWidth: 280,
        },
      }}
    >
      <Box
        sx={{
          height: '100%',
          padding: 1,
        }}
      >
        <SidebarNav pages={pages} />
      </Box>
    </Drawer>
  );
};

export default Sidebar;
